import { IconTicket } from '@/assets/icons/IconTicket';
import { AuthWrapper } from '@/features/core/auth/screens/AuthWrapper';
import React from 'react';
import { TutorialApp } from '@/features/tickets/components/TutorialApp';

export const TicketsContainer: React.FC = () => (
  <AuthWrapper isHomepage={false}>
    <div className="w-full p-7 md:px-0 container mx-auto py-24">
      <header className="flex flex-wrap items-center mb-[70px]">
        <div className="w-full flex justify-between items-center">
          <div className="flex items-center">
            <IconTicket className="mr-[20px] h-[30px]" />
            <h1 className="font-dmsans font-medium text-[37px]">Acesso aos ingressos</h1>
          </div>
        </div>
        <TutorialApp />
      </header>
    </div>
  </AuthWrapper>
);
